import React from "react";
import { Link as RouterLink } from "react-router-dom";

const instrumentSerif = { fontFamily: "'Instrument Serif', Georgia, serif" };
const geistMono = { fontFamily: "'Geist Mono', monospace" };

const CTA = () => {
	return (
		<>
			<style>{`
				@media (max-width: 767px) {
					.cta-section {
						padding: 40px 16px !important;
						display: flex !important;
						justify-content: center !important;
					}
					.cta-card {
						width: 358px !important;
						height: 328px !important;
						max-width: 100% !important;
						border-radius: 16px !important;
					}
					.cta-content {
						width: min(305px, calc(100% - 48px)) !important;
					}
					.cta-buttons {
						flex-wrap: wrap !important;
						gap: 8px !important;
					}
					.cta-buttons a {
						height: 36px !important;
						font-size: 14px !important;
						padding: 0 8px !important;
					}
				}
			`}</style>

			<section
				className="cta-section"
				style={{
					width: "100%",
					backgroundColor: "#FFFFFF",
					boxSizing: "border-box",
					padding: "0 clamp(20px, 5.56vw, 80px) clamp(48px, 6.94vw, 100px)",
				}}
			>
				{/* Card */}
				<div
					className="cta-card"
					style={{
						maxWidth: "1280px",
						margin: "0 auto",
						backgroundColor: "#132A22",
						borderRadius: "20px",
						boxSizing: "border-box",
						overflow: "hidden",
						position: "relative",
						height: "496px",
					}}
				>
					{/* Content — absolutely centered */}
					<div
						className="cta-content"
						style={{
							position: "absolute",
							left: "50%",
							top: "50%",
							transform: "translate(-50%, -50%)",
							width: "min(693px, calc(100% - 48px))",
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							gap: "32px",
							textAlign: "center",
						}}
					>
						{/* Label + Heading + Subtitle */}
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								gap: "16px",
								width: "100%",
							}}
						>
							{/* Label + Heading tight sub-block */}
							<div
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
									gap: "0px",
									width: "100%",
								}}
							>
								{/* Label */}
								<div style={{ display: "flex", alignItems: "center", gap: "8px", height: "32px" }}>
									<span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#86C7A8", flexShrink: 0, display: "inline-block" }} />
									<span
										style={{
											...geistMono,
											fontWeight: 500,
											fontSize: "14px",
											lineHeight: "32px",
											letterSpacing: "0.08em",
											color: "#86C7A8",
											textTransform: "uppercase",
											whiteSpace: "nowrap",
										}}
									>
										Get Started
									</span>
								</div>

								{/* Heading */}
								<h2
									style={{
										...instrumentSerif,
										fontWeight: 400,
										fontSize: "clamp(32px, 4.17vw, 60px)",
										lineHeight: "1.167",
										color: "#FFFFFF",
										margin: 0,
									}}
								>
									Ready to get started with smarter banking?
								</h2>
							</div>

							{/* Subtitle */}
							<p
								style={{
									fontFamily: "'Geist', sans-serif",
									fontWeight: 400,
									fontSize: "clamp(14px, 1.39vw, 20px)",
									lineHeight: "32px",
									color: "#DEDEDE",
									margin: 0,
									maxWidth: "495px",
								}}
							>
								Open your account in minutes or download the Zikora App to bank anytime, anywhere.
							</p>
						</div>

						{/* Buttons */}
						<div
							className="cta-buttons"
							style={{
								display: "flex",
								gap: "12px",
								justifyContent: "center",
							}}
						>
							<RouterLink
								to="/signup"
								style={{
									fontFamily: "'Geist', sans-serif",
									display: "inline-flex",
									alignItems: "center",
									justifyContent: "center",
									height: "52px",
									padding: "0 24px",
									backgroundColor: "#86C7A8",
									borderRadius: "8px",
									fontWeight: 600,
									fontSize: "clamp(13px, 1.11vw, 16px)",
									lineHeight: "20px",
									color: "#132A22",
									textDecoration: "none",
									whiteSpace: "nowrap",
								}}
							>
								Open Account
							</RouterLink>

							<a
								href="https://onelink.to/zikora"
								target="_blank"
								rel="noopener noreferrer"
								style={{
									fontFamily: "'Geist', sans-serif",
									display: "inline-flex",
									alignItems: "center",
									justifyContent: "center",
									height: "52px",
									padding: "0 24px",
									backgroundColor: "transparent",
									border: "1px solid #DEDEDE",
									borderRadius: "8px",
									fontWeight: 600,
									fontSize: "clamp(13px, 1.11vw, 16px)",
									lineHeight: "20px",
									color: "#FFFFFF",
									textDecoration: "none",
									whiteSpace: "nowrap",
								}}
							>
								Download the App
							</a>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default CTA;
